import React, { useState } from 'react';
import { FaPlus, FaMinus, FaFolder } from 'react-icons/fa';

const Folder = ({ folder, children, handleFolderSelect, isSelected }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ paddingLeft: '20px', borderLeft: '1px solid #ddd' }}>
      <div className="flex items-center gap-1">
        <span onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer' }}>
          {isOpen ? <FaMinus /> : <FaPlus />}
        </span>
        <label className="text-red-500 flex items-center gap-1">
          <FaFolder />
          <input
            className="text-red-500"
            type="radio"
            checked={isSelected(folder._id)}
            onChange={() => handleFolderSelect(folder._id)}
          />
          <span>{folder.name}</span>
        </label>
      </div>
      {isOpen && (
        <div>
          {children?.map(child => (
            <Folder
              key={child._id}
              folder={child}
              children={child.children}
              handleFolderSelect={handleFolderSelect}
              isSelected={isSelected}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const FolderTree = ({ folders, setFolderId }) => {
  const [selectedFolder, setSelectedFolder] = useState(null);

  // Helper to manage folder selection
  const handleFolderSelect = folderId => {
    setSelectedFolder(folderId);
    setFolderId(folderId);
  };

  const isSelected = folderId => selectedFolder === folderId;

  // Function to build the folder tree
  const buildTree = folders => {
    const folderMap = {};
    const roots = [];

    folders.forEach(folder => {
      folderMap[folder._id] = { ...folder, children: [] };
    });

    folders.forEach(folder => {
      if (folder.parent) {
        folderMap[folder.parent]?.children.push(folderMap[folder._id]);
      } else {
        roots.push(folderMap[folder._id]);
      }
    });

    return roots;
  };

  const tree = buildTree(folders);

  return (
    <div>
      {tree.map(folder => (
        <Folder
          key={folder._id}
          folder={folder}
          children={folder.children}
          handleFolderSelect={handleFolderSelect}
          isSelected={isSelected}
        />
      ))}
    </div>
  );
};

export default FolderTree;
